var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.66667H16.25V6.19048C16.25 2.77333 13.45 0 10 0C6.55 0 3.75 2.77333 3.75 6.19048V8.66667H2.5C1.11875 8.66667 0 9.77476 0 11.1429V23.5238C0 24.8919 1.11875 26 2.5 26H17.5C18.8813 26 20 24.8919 20 23.5238V11.1429C20 9.77476 18.8813 8.66667 17.5 8.66667ZM10 19.8095C8.61875 19.8095 7.5 18.7014 7.5 17.3333C7.5 15.9652 8.61875 14.8571 10 14.8571C11.3813 14.8571 12.5 15.9652 12.5 17.3333C12.5 18.7014 11.3813 19.8095 10 19.8095ZM13.875 8.66667H6.125V6.19048C6.125 4.07333 7.8625 2.35238 10 2.35238C12.1375 2.35238 13.875 4.07333 13.875 6.19048V8.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.fa3393ef02082d830cc9cd46aef2b966.svg";
export { ForwardRef as ReactComponent };